import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">NATURAL SWEET GOOD Sp. z o.o.  Sp. k. &copy; 2020</span>
      </footer>
    );
  }
;

export default Footer;
